import { render, staticRenderFns } from "./ChallengesListWidget.vue?vue&type=template&id=4a093b1b"
import script from "./ChallengesListWidget.vue?vue&type=script&lang=js"
export * from "./ChallengesListWidget.vue?vue&type=script&lang=js"
import style0 from "./ChallengesListWidget.vue?vue&type=style&index=0&id=4a093b1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports